module.exports = __webpack_public_path__ + "img/九节菖蒲.300d9446.jpg";